/**
 * Señales con las que los navegadores anuncian que un módulo perezoso no bajó.
 * Cada motor redacta el suyo, así que se busca por trozos y en minúsculas en vez
 * de comparar mensajes completos.
 *
 * Vive aparte y sin dependencias porque la leen dos sitios que no se pueden
 * importar entre sí: el router (`app.config`) y el arranque (`main.ts`), que
 * justo falla cuando `app.config` no llegó a descargarse.
 */
export const SENALES_DE_CHUNK_CAIDO = [
  'dynamically imported module', // Chrome, Edge y Firefox
  'importing a module script failed', // Safari
  'chunkloaderror', // nombre del error, no mensaje
  'failed to fetch', // el módulo ni siquiera llegó a pedirse bien
  // Tras un despliegue, el index.html que el navegador tiene cacheado pide un
  // chunk cuyo hash ya no existe. El servidor de una SPA no devuelve 404: sirve
  // el index.html de respaldo, y el navegador rechaza el módulo por tipo MIME.
  // Es el fallo de chunk MÁS habitual en producción y no se parece a los otros.
  'expected a javascript module script',
  'mime type',
] as const;

/**
 * ¿El error tiene pinta de «el módulo no se descargó»?
 *
 * Sólo mira el nombre y el mensaje. Descartar antes los errores con una respuesta
 * HTTP detrás le toca a quien llama cuando puede haberlos (el router, por sus
 * guards y resolvers); en el arranque no hay ninguno.
 */
export function pareceChunkQueNoCargo(error: unknown): boolean {
  // El error llega como `unknown` y puede ser cualquier cosa: un TypeError del
  // navegador, un ChunkLoadError del empaquetador o hasta una cadena suelta. Se
  // miran el nombre y el mensaje, y si no hay ninguno se recurre al valor en crudo.
  const suelto = error as { name?: unknown; message?: unknown } | null;
  const nombre = typeof suelto?.name === 'string' ? suelto.name : '';
  const mensaje =
    typeof suelto?.message === 'string' ? suelto.message : String(error ?? '');
  const texto = `${nombre} ${mensaje}`.toLowerCase();

  return SENALES_DE_CHUNK_CAIDO.some((senal) => texto.includes(senal));
}
